export const NewLeadsMap = {
  GET_ALL_NEW_LEADS_START: "GET_ALL_NEW_LEADS_START",
  GET_ALL_NEW_LEADS_SUCCESS: "GET_ALL_NEW_LEADS_SUCCESS",
  GET_ALL_NEW_LEADS_ERROR: "GET_ALL_NEW_LEADS_ERROR",
  SEARCH_TEXT_CHANGE: "NEW_LEADS_SEARCH_TEXT_CHANGE",
  SET_NEW_LEADS_BATCH_NUMBER: "SET_NEW_LEADS_BATCH_NUMBER",
  GET_NEW_LEAD_START: "GET_NEW_LEAD_START",
  GET_NEW_LEAD_SUCCESS: "GET_NEW_LEAD_SUCCESS",
  GET_NEW_LEAD_ERROR: "GET_NEW_LEAD_ERROR",
  SET_AUDIO_TYPE: "NEW_LEADS_SET_AUDIO_TYPE",
  SET_BATCH_FILTER: "NEW_LEADS_SET_BATCH_FILTER",
  SET_DATE_FILTER: "NEW_LEADS_SET_DATE_FILTER",
  SET_FROM_DATE_FILTER: "NEW_LEADS_SET_FROM_DATE_FILTER",
  SET_TO_DATE_FILTER: "NEW_LEADS_SET_TO_DATE_FILTER",
  SET_LEAD_TYPE: "NEW_LEADS_SET_LEAD_TYPE",
  SET_CALL_OUTCOME_FILTER: "NEW_LEADS_SET_CALL_OUTCOME_FILTER",
  SET_COMPANY_NAME_FILTER: "NEW_LEADS_SET_COMPANY_NAME_FILTER",
  SET_CREATED_BY_FILTER: "NEW_LEADS_SET_CREATED_BY_FILTER",
  SET_LIMIT: "NEW_LEADS_SET_LIMIT",
  RESET_REFRESH_FLAG: "NEW_LEADS_RESET_REFRESH_FLAG",
};

export const newLeadsAction = {
  getAllNewLeadsStart: () => ({
    type: NewLeadsMap.GET_ALL_NEW_LEADS_START,
  }),
  getAllNewLeadsSuccess: (payload) => ({
    type: NewLeadsMap.GET_ALL_NEW_LEADS_SUCCESS,
    payload,
  }),
  getAllNewLeadsError: () => ({
    type: NewLeadsMap.GET_ALL_NEW_LEADS_ERROR,
  }),
  searchTextChange: (text) => ({
    type: NewLeadsMap.SEARCH_TEXT_CHANGE,
    payload: text,
  }),
  setNewLeadsBatchNumber: (batchNumber) => ({
    type: NewLeadsMap.SET_NEW_LEADS_BATCH_NUMBER,
    payload: batchNumber,
  }),
  getNewLeadStart: () => ({
    type: NewLeadsMap.GET_NEW_LEAD_START,
  }),
  getNewLeadSuccess: (payload) => ({
    type: NewLeadsMap.GET_NEW_LEAD_SUCCESS,
    payload,
  }),
  getNewLeadError: () => ({
    type: NewLeadsMap.GET_NEW_LEAD_ERROR,
  }),
  setAudioType: (audioType) => ({
    type: NewLeadsMap.SET_AUDIO_TYPE,
    payload: audioType,
  }),
  setBatchFilter: (batchName) => ({
    type: NewLeadsMap.SET_BATCH_FILTER,
    payload: batchName,
  }),
  setDateFilter: (date) => ({
    type: NewLeadsMap.SET_DATE_FILTER,
    payload: date,
  }),
  setFromDateFilter: (date) => ({
    type: NewLeadsMap.SET_FROM_DATE_FILTER,
    payload: date,
  }),
  setToDateFilter: (date) => ({
    type: NewLeadsMap.SET_TO_DATE_FILTER,
    payload: date,
  }),
  setLeadType: (leadType) => ({
    type: NewLeadsMap.SET_LEAD_TYPE,
    payload: leadType,
  }),
  setCallOutcomeFilter: (callOutcome) => ({
    type: NewLeadsMap.SET_CALL_OUTCOME_FILTER,
    payload: callOutcome,
  }),
  setCompanyNameFilter: (value) => ({
    type: NewLeadsMap.SET_COMPANY_NAME_FILTER,
    payload: value,
  }),
  setCreatedByFilter: (createdBy) => ({
    type: NewLeadsMap.SET_CREATED_BY_FILTER,
    payload: createdBy,
  }),
  setLimit: (limit) => ({
    type: NewLeadsMap.SET_LIMIT,
    payload: limit,
  }),
  resetRefreshFlag: () => ({
    type: NewLeadsMap.RESET_REFRESH_FLAG,
  }),
};
